/* global Vue */

import { useCurrencyObserver, changeTextCurrency } from '../../use-currency-observer'
import CldImg from './CldImg'
import OfferSliderCardUnit from './OfferSliderCardUnit'

export default {
  name: 'OfferSliderCard',
  components: { OfferSliderCardUnit, CldImg },
  template: `
    <OfferSliderCardUnit v-if="cardType == 'unit'" :offer="offer" :teaser="teaser" :buttonText="buttonText" />
    <div v-else class="card" :class="extraClasses" style="opacity: 1; transform: translate(0px, 0px);">
      <div class="card__image">
        <a :href="offer.link" :title="offer.title">
          <CldImg :src="offer.image" :alt="offer.title" />
        </a>
      </div>
      <div class="card__tags"></div>
      <div>
        <a class="h3" :href="offer.link">{{ offer.title }}</a>
      </div>
      <span v-if="offer.properties.length === 1" class="card__property">{{ offer.properties[0].split('-').join(' ') }}</span>
      <span v-if="teaser" class="card__teaser">{{ teaser }}</span>
      <p>{{ offer.description }}</p>
      <div class="card__buttons">
        <a :href="offer.link" class="button button--outline">{{ $t(buttonText) }}</a>
      </div>
    </div>
  `,
  props: { offer: Object, cardType: String, buttonText: String, extraClasses: Array },
  setup (props) {
    const { offer, cardType, buttonText } = Vue.toRefs(props)
    const teaser = Vue.ref('')

    const currency = useCurrencyObserver()
    Vue.watch(currency, () => {
      teaser.value = changeTextCurrency(offer.value.teaser)
    }, { immediate: true })

    return {
      cardType,
      offer,
      teaser,
      buttonText,
    }
  },
}
